import { startCase } from 'es-toolkit';
import React from 'react';
import EditIcon from '@mui/icons-material/Edit';

import { SelectedItemIdentifier } from '../../../../library/selection/types';
import { TransformationMenuItems } from '../../../../library/transformations/controls/TransformationMenuItems';
import { useAppMonitor } from '../../../../monitor';
import { handleStandardSceneItemsEditPropertiesAction } from '../../../../store/actions/sceneInteractionActions';
import { useAppDispatch, useAppSelector } from '../../../hooks';
import { SceneMenuContent } from '../common/SceneMenuContent';
import { SceneMenuItem } from '../common/SceneMenuItem';
import { DeleteMenuItem } from '../shared-menu-items/DeleteMenuItem';

export function FeatureAreaMenu(props: { items: SelectedItemIdentifier[] }) {
  const monitor = useAppMonitor();
  const dispatch = useAppDispatch();

  const guids = new Set(props.items.map((item) => item.guid));

  const featureAreas = useAppSelector((state) =>
    Object.values(state.layout.featurePatternContainers).flatMap((container) =>
      container.featureAreas.filter((area) => guids.has(area.guid)),
    ),
  );

  if (featureAreas.length < props.items.length) throw new Error('Unable to find feature area with active menu.');

  return (
    <SceneMenuContent>
      <SceneMenuItem
        text="Edit Properties"
        icon={<EditIcon />}
        onClick={async () => {
          await dispatch(handleStandardSceneItemsEditPropertiesAction('featureArea', featureAreas));
          monitor.recordInteraction('Feature Area => Edit Properties menu item clicked');
        }}
      />

      <TransformationMenuItems />

      <DeleteMenuItem
        type="featureArea"
        item={featureAreas}
        userVisibleTerm={featureAreas.length === 1 ? startCase(featureAreas[0].featureType) : 'Feature Areas'}
      />
    </SceneMenuContent>
  );
}
